import type { TranslationKey } from '@change-corgi/core/i18n';

import { usePetitionEditPageState } from '#src/app/pages/petitionEditV2/pageContext';
import type { GeoScope, Place } from '#src/app/shared/components/googlePlaces';

type UseLocationReturn = ModelHookResult<
	{
		place: Place | null;
		geoReach?: GeoScope;
		error: TranslationKey | null;
	},
	{
		onSelect: (place: Place | null) => void;
	}
>;

export function useLocation(): UseLocationReturn {
	const [state, mutations] = usePetitionEditPageState();
	const location = state.formState.relevantLocation.value;
	const geoReach = location?.geoReach as GeoScope | undefined;
	const { error } = state.formState.relevantLocation;
	const place: Place | null =
		location?.googlePlacesId && location.localizedName
			? {
					googlePlacesId: location.googlePlacesId,
					displayName: location.localizedName,
				}
			: null;

	const onSelect = (selectedPlace: Place | null) => {
		if (state.formState.relevantLocation.error) {
			mutations.resetFieldError('relevantLocation');
		}

		if (selectedPlace) {
			mutations.setLocation({
				googlePlacesId: selectedPlace.googlePlacesId,
				localizedName: selectedPlace.displayName,
				geoReach,
			});
		} else {
			mutations.setLocation({ googlePlacesId: undefined, localizedName: undefined });
		}
	};

	return {
		data: {
			place,
			geoReach,
			error,
		},
		actions: {
			onSelect,
		},
	};
}
